import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { images } from "../../Images/Svg";
import classes from "./commonModal.module.css";
import ReactPanZoom from "react-image-pan-zoom-rotate";
const CommonModal = ({
  label,
  open,
  children,
  onClose = () => {},
  sx = {},
  height = "auto",
  width = "none",
  maxWidth = "100%",
  hideBackdrop = false,
  showCrossIcon = true,
  showDownloadIcon = false,
  downloadFilePath,
  downloadFileName,
  isImage = false,
  fullsize = false,
}) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: fullsize ? "100%" : width,
    height: fullsize ? "100%" : height,
    maxWidth: fullsize ? "100%" : maxWidth,
    maxHeight: fullsize ? "100%" : "80%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "2px solid #fff",
    boxShadow: 24,
    borderRadius: "4px",
    // pt: 2,
    px: 3,
    pb: 2,
  };

  const downloadCsvApi = () => {
    fetch(downloadFilePath, {
      method: "GET",
      headers: {
        "Content-Type": "application/pdf",
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", downloadFileName || "chase_document");

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
      })
      .catch((err) => {});
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      disableAutoFocus={true}
      disableEnforceFocus={true}
      hideBackdrop={hideBackdrop}
    >
      <Box
        sx={{ ...style, ...sx }}
        className={classes["scroller"]}
        id="comman-modal"
      >
        {showCrossIcon ? (
          <>
            <div className={classes["icon"]}>
              <h1
                style={{
                  color: "#505050",
                  fontWeight: "600",
                  fontSize: "1.6rem",
                }}
              >
                {label}
              </h1>
              {showDownloadIcon ? (
                <img
                  style={{
                    position: "absolute",
                    right: "22px",
                    bottom: "5px",
                    cursor: "pointer",
                    top: "10px",
                  }}
                  src={images?.DownloadIcon}
                  alt="download icon"
                  onClick={downloadCsvApi}
                />
              ) : null}
              <img
                style={{
                  position: "absolute",
                  right: "-5px",
                  cursor: "pointer",
                  top: "13px",
                }}
                src={images?.crossIcon}
                // width={"100%"}
                // height={"100%"}
                alt="cancel icon"
                onClick={(e) => onClose(e, true)}
              />
            </div>
          </>
        ) : null}
        {children}
      </Box>
    </Modal>
  );
};

export default CommonModal;
